import { CITY_LIST } from "./cities";

export const TYPES = [
  { id: "studio", label: "Studio", mult: 0.7 },
  { id: "appartement", label: "Appartement", mult: 1 },
  { id: "maison", label: "Maison", mult: 1.35 },
  { id: "villa", label: "Villa", mult: 1.9 },
];

// Saisonnalité Côte d'Émeraude (taux d'occupation moyen)
export const SEASON = [
  { m: "Jan", occ: 0.38, p: 0.8 },
  { m: "Fév", occ: 0.45, p: 0.82 },
  { m: "Mar", occ: 0.5, p: 0.85 },
  { m: "Avr", occ: 0.66, p: 0.95 },
  { m: "Mai", occ: 0.74, p: 1.02 },
  { m: "Juin", occ: 0.8, p: 1.1 },
  { m: "Juil", occ: 0.94, p: 1.45 },
  { m: "Août", occ: 0.97, p: 1.55 },
  { m: "Sep", occ: 0.78, p: 1.08 },
  { m: "Oct", occ: 0.6, p: 0.9 },
  { m: "Nov", occ: 0.42, p: 0.8 },
  { m: "Déc", occ: 0.5, p: 0.92 },
];

export function estimate({ city = "Saint-Malo", type = "appartement", bedrooms = 1, guests = 2 }) {
  const c = CITY_LIST.find((x) => x.name === city) || CITY_LIST[0];
  const t = TYPES.find((x) => x.id === type) || TYPES[1];
  const nightly = 0.82 * c.base * t.mult * (1 + (Number(bedrooms) - 1) * 0.28) * (1 + (Number(guests) - 2) * 0.04);
  const months = SEASON.map((s) => ({ m: s.m, value: Math.round(nightly * s.p * s.occ * 30) }));
  const annual = months.reduce((a, b) => a + b.value, 0);
  return { nightly: Math.round(nightly), months, annual, monthly: Math.round(annual / 12) };
}
